var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"logistics"}},[_c('b-row',{staticClass:"logistics__main"},[_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('SelectionSect',{attrs:{"farm":_vm.farm}})],1),_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('DisplaySect')],1)],1),_c('div',{staticClass:"logistics__mobile-err"},[_vm._v(" Mobile view is not supported ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }